import React from "react";

import { cartMachine } from "./CartMachine";
import { createActorContext } from "@xstate/react";
import { ActorOptions } from "xstate";

export const CartActorContext = createActorContext(cartMachine);

export function CartActorProvider(
  props: React.PropsWithChildren & { options?: ActorOptions<typeof cartMachine> }
) {
  return (
    <CartActorContext.Provider options={props.options}>
      {props.children}
    </CartActorContext.Provider>
  );
}

export function useCartActor() {
  return CartActorContext.useActorRef();
}
